import { render, staticRenderFns } from "./referrer-checklist-tab.vue?vue&type=template&id=19e8f5e7"
import script from "./referrer-checklist-tab.vue?vue&type=script&lang=js"
export * from "./referrer-checklist-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports